import type { HTMLAttributes, ReactNode } from 'react'

/** Uppercase Jost label with short signal-blue accent rule underneath. */
export function EsEyebrow({
  className = '',
  children,
  ...rest
}: HTMLAttributes<HTMLParagraphElement> & { children: ReactNode }) {
  return (
    <div className={className}>
      <p
        className="font-esDisplay font-semibold text-[var(--fs-eyebrow)] uppercase tracking-[var(--eyebrow-spacing)] text-es-signal"
        {...rest}
      >
        {children}
      </p>
      <span
        className="mt-2 block h-[var(--accent-rule-h)] w-[var(--accent-rule-w)] bg-es-signal"
        aria-hidden
      />
    </div>
  )
}

/** Full-width 2px navy rule under an action title. */
export function EsTitleRule({ className = '' }: { className?: string }) {
  return (
    <span
      className={`mt-3 block h-[var(--title-rule-h)] w-full bg-es-navy ${className}`}
      aria-hidden
    />
  )
}

export function EsPageHeader({
  eyebrow,
  title,
  description,
  beta = false,
  className = '',
}: {
  eyebrow?: string
  title: string
  description?: string
  /** Show a small Beta badge next to the title (e.g. feature still in development). */
  beta?: boolean
  className?: string
}) {
  return (
    <header className={`mb-6 ${className}`}>
      {eyebrow ? <EsEyebrow className="mb-3">{eyebrow}</EsEyebrow> : null}
      <h1 className="text-es-navy">
        {title}
        {beta ? (
          <span
            className="ml-2 inline-block rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide leading-none align-middle border border-current opacity-90"
            aria-label="Beta"
          >
            Beta
          </span>
        ) : null}
      </h1>
      <EsTitleRule />
      {description ? (
        <p className="mt-3 text-sm text-es-muted max-w-3xl">{description}</p>
      ) : null}
    </header>
  )
}
